// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PanUploadSection_panSectionWrapper__L\\+I4M {
  margin: 1.5rem 0 2rem 0;
  padding: 1.25rem 1.5rem;
  background: #ffffff;
  border: 1.5px solid #fee2e2;
  border-left: 5px solid #ef4444;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.06);
  font-family: 'CircularXXWeb-Book', -apple-system, BlinkMacSystemFont, sans-serif;
  animation: PanUploadSection_fadeIn__Kxlbu 0.3s ease;
}

.PanUploadSection_sectionHeader__1kP6C {
  margin-bottom: 1rem;
}

.PanUploadSection_titleRow__juDyN {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.PanUploadSection_idIcon__Ur\\+Wf {
  color: #dc2626;
  flex-shrink: 0;
}

.PanUploadSection_sectionTitle__\\+BQd1 {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1f2937;
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.PanUploadSection_requiredAsterisk__fNCd8 {
  color: #dc2626;
  font-size: 1.15rem;
  font-weight: 800;
}

.PanUploadSection_sectionSubtitle__5zqst {
  font-size: 0.88rem;
  color: #6b7280;
  margin: 0.3rem 0 0 0;
  line-height: 1.4;
}

.PanUploadSection_dropZone__Wx4r2 {
  border: 2px dashed #fca5a5;
  border-radius: 10px;
  padding: 1.75rem 1.25rem;
  text-align: center;
  background: #fffafa;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 140px;
}

.PanUploadSection_dropZone__Wx4r2:hover,
.PanUploadSection_dropZoneActive__driF- {
  border-color: #ef4444;
  background: #fef2f2;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(239, 68, 68, 0.1);
}

.PanUploadSection_dropZoneError__Dp5kH {
  border-color: #dc2626;
  background: #fff1f2;
}

.PanUploadSection_hiddenFileInput__EywCt {
  display: none;
}

.PanUploadSection_emptyState__1KrlJ {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
}

.PanUploadSection_cloudIconWrapper__0Uylx {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #fee2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.35rem;
}

.PanUploadSection_dropText__X4flN {
  font-size: 0.95rem;
  color: #374151;
  margin: 0;
}

.PanUploadSection_dropText__X4flN strong {
  color: #ef4444;
  text-decoration: underline;
}

.PanUploadSection_formatHint__EmVFI {
  font-size: 0.78rem;
  color: #9ca3af;
  margin: 0;
}

.PanUploadSection_uploadingState__itKpp {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
}

.PanUploadSection_spinner__03aKk {
  width: 32px;
  height: 32px;
  border: 3px solid #fecaca;
  border-top-color: #ef4444;
  border-radius: 50%;
  animation: PanUploadSection_spin__Fwi9l 0.8s linear infinite;
}

.PanUploadSection_uploadingText__mknSi {
  font-size: 0.9rem;
  color: #dc2626;
  font-weight: 600;
  margin: 0;
}

.PanUploadSection_previewState__2ssF- {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.PanUploadSection_imgPreview__tfJUX {
  max-height: 120px;
  max-width: 220px;
  object-fit: contain;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.PanUploadSection_pdfBadge__qTtuP {
  background: #fee2e2;
  color: #dc2626;
  font-size: 1.1rem;
  font-weight: 800;
  padding: 0.6rem 1.4rem;
  border-radius: 8px;
  border: 1.5px solid #fca5a5;
  letter-spacing: 0.05em;
}

.PanUploadSection_fileSelectedText__0BJdK {
  font-size: 0.85rem;
  color: #4b5563;
  margin: 0;
  font-weight: 600;
}

.PanUploadSection_reselectBtn__Zc78i {
  background: none;
  border: none;
  color: #ef4444;
  font-size: 0.82rem;
  text-decoration: underline;
  cursor: pointer;
  padding: 0.2rem;
  font-weight: 600;
}

.PanUploadSection_uploadedCard__GCfkq {
  background: #f0fdf4;
  border: 1.5px solid #86efac;
  border-radius: 10px;
  padding: 1rem 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.PanUploadSection_uploadedLeft__fC9bk {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

.PanUploadSection_successCheckIcon__O99gu {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #dcfce7;
  color: #16a34a;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.PanUploadSection_uploadedInfo__DuLyn {
  display: flex;
  flex-direction: column;
}

.PanUploadSection_uploadedTitle__kVpEi {
  font-size: 0.95rem;
  font-weight: 700;
  color: #15803d;
}

.PanUploadSection_uploadedSubtitle__FI36q {
  font-size: 0.82rem;
  color: #4b5563;
  margin-top: 0.25rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.PanUploadSection_panBadge__pljcR {
  background: #dcfce7;
  color: #15803d;
  font-weight: 700;
  padding: 0.15rem 0.45rem;
  border-radius: 4px;
  border: 1px solid #86efac;
  font-size: 0.78rem;
  letter-spacing: 0.04em;
}

.PanUploadSection_fileNameText__\\+QkoJ {
  color: #374151;
  font-weight: 600;
  word-break: break-all;
}

.PanUploadSection_changeFileBtn__SLh1Y {
  background: #ffffff;
  border: 1.5px solid #cbd5e1;
  color: #475569;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.45rem 0.9rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.PanUploadSection_changeFileBtn__SLh1Y:hover {
  background: #f8fafc;
  border-color: #94a3b8;
  color: #1e293b;
}

.PanUploadSection_errorMessage__Hf4Ba {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.6rem;
  color: #dc2626;
  font-size: 0.82rem;
  font-weight: 600;
}

@keyframes PanUploadSection_spin__Fwi9l {
  to {
    transform: rotate(360deg);
  }
}

@keyframes PanUploadSection_fadeIn__Kxlbu {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/organism/PanUploadSection.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB;EACnB,8CAA8C;EAC9C,gFAAgF;EAChF,mDAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,4DAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".panSectionWrapper {\n  margin: 1.5rem 0 2rem 0;\n  padding: 1.25rem 1.5rem;\n  background: #ffffff;\n  border: 1.5px solid #fee2e2;\n  border-left: 5px solid #ef4444;\n  border-radius: 12px;\n  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.06);\n  font-family: 'CircularXXWeb-Book', -apple-system, BlinkMacSystemFont, sans-serif;\n  animation: fadeIn 0.3s ease;\n}\n\n.sectionHeader {\n  margin-bottom: 1rem;\n}\n\n.titleRow {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.idIcon {\n  color: #dc2626;\n  flex-shrink: 0;\n}\n\n.sectionTitle {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #1f2937;\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.requiredAsterisk {\n  color: #dc2626;\n  font-size: 1.15rem;\n  font-weight: 800;\n}\n\n.sectionSubtitle {\n  font-size: 0.88rem;\n  color: #6b7280;\n  margin: 0.3rem 0 0 0;\n  line-height: 1.4;\n}\n\n.dropZone {\n  border: 2px dashed #fca5a5;\n  border-radius: 10px;\n  padding: 1.75rem 1.25rem;\n  text-align: center;\n  background: #fffafa;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 140px;\n}\n\n.dropZone:hover,\n.dropZoneActive {\n  border-color: #ef4444;\n  background: #fef2f2;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(239, 68, 68, 0.1);\n}\n\n.dropZoneError {\n  border-color: #dc2626;\n  background: #fff1f2;\n}\n\n.hiddenFileInput {\n  display: none;\n}\n\n.emptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.cloudIconWrapper {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: #fee2e2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.35rem;\n}\n\n.dropText {\n  font-size: 0.95rem;\n  color: #374151;\n  margin: 0;\n}\n\n.dropText strong {\n  color: #ef4444;\n  text-decoration: underline;\n}\n\n.formatHint {\n  font-size: 0.78rem;\n  color: #9ca3af;\n  margin: 0;\n}\n\n.uploadingState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.8rem;\n}\n\n.spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #fecaca;\n  border-top-color: #ef4444;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n.uploadingText {\n  font-size: 0.9rem;\n  color: #dc2626;\n  font-weight: 600;\n  margin: 0;\n}\n\n.previewState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.imgPreview {\n  max-height: 120px;\n  max-width: 220px;\n  object-fit: contain;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.pdfBadge {\n  background: #fee2e2;\n  color: #dc2626;\n  font-size: 1.1rem;\n  font-weight: 800;\n  padding: 0.6rem 1.4rem;\n  border-radius: 8px;\n  border: 1.5px solid #fca5a5;\n  letter-spacing: 0.05em;\n}\n\n.fileSelectedText {\n  font-size: 0.85rem;\n  color: #4b5563;\n  margin: 0;\n  font-weight: 600;\n}\n\n.reselectBtn {\n  background: none;\n  border: none;\n  color: #ef4444;\n  font-size: 0.82rem;\n  text-decoration: underline;\n  cursor: pointer;\n  padding: 0.2rem;\n  font-weight: 600;\n}\n\n.uploadedCard {\n  background: #f0fdf4;\n  border: 1.5px solid #86efac;\n  border-radius: 10px;\n  padding: 1rem 1.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.uploadedLeft {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n}\n\n.successCheckIcon {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #dcfce7;\n  color: #16a34a;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.uploadedInfo {\n  display: flex;\n  flex-direction: column;\n}\n\n.uploadedTitle {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #15803d;\n}\n\n.uploadedSubtitle {\n  font-size: 0.82rem;\n  color: #4b5563;\n  margin-top: 0.25rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.panBadge {\n  background: #dcfce7;\n  color: #15803d;\n  font-weight: 700;\n  padding: 0.15rem 0.45rem;\n  border-radius: 4px;\n  border: 1px solid #86efac;\n  font-size: 0.78rem;\n  letter-spacing: 0.04em;\n}\n\n.fileNameText {\n  color: #374151;\n  font-weight: 600;\n  word-break: break-all;\n}\n\n.changeFileBtn {\n  background: #ffffff;\n  border: 1.5px solid #cbd5e1;\n  color: #475569;\n  font-size: 0.82rem;\n  font-weight: 600;\n  padding: 0.45rem 0.9rem;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.changeFileBtn:hover {\n  background: #f8fafc;\n  border-color: #94a3b8;\n  color: #1e293b;\n}\n\n.errorMessage {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-top: 0.6rem;\n  color: #dc2626;\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panSectionWrapper": `PanUploadSection_panSectionWrapper__L+I4M`,
	"fadeIn": `PanUploadSection_fadeIn__Kxlbu`,
	"sectionHeader": `PanUploadSection_sectionHeader__1kP6C`,
	"titleRow": `PanUploadSection_titleRow__juDyN`,
	"idIcon": `PanUploadSection_idIcon__Ur+Wf`,
	"sectionTitle": `PanUploadSection_sectionTitle__+BQd1`,
	"requiredAsterisk": `PanUploadSection_requiredAsterisk__fNCd8`,
	"sectionSubtitle": `PanUploadSection_sectionSubtitle__5zqst`,
	"dropZone": `PanUploadSection_dropZone__Wx4r2`,
	"dropZoneActive": `PanUploadSection_dropZoneActive__driF-`,
	"dropZoneError": `PanUploadSection_dropZoneError__Dp5kH`,
	"hiddenFileInput": `PanUploadSection_hiddenFileInput__EywCt`,
	"emptyState": `PanUploadSection_emptyState__1KrlJ`,
	"cloudIconWrapper": `PanUploadSection_cloudIconWrapper__0Uylx`,
	"dropText": `PanUploadSection_dropText__X4flN`,
	"formatHint": `PanUploadSection_formatHint__EmVFI`,
	"uploadingState": `PanUploadSection_uploadingState__itKpp`,
	"spinner": `PanUploadSection_spinner__03aKk`,
	"spin": `PanUploadSection_spin__Fwi9l`,
	"uploadingText": `PanUploadSection_uploadingText__mknSi`,
	"previewState": `PanUploadSection_previewState__2ssF-`,
	"imgPreview": `PanUploadSection_imgPreview__tfJUX`,
	"pdfBadge": `PanUploadSection_pdfBadge__qTtuP`,
	"fileSelectedText": `PanUploadSection_fileSelectedText__0BJdK`,
	"reselectBtn": `PanUploadSection_reselectBtn__Zc78i`,
	"uploadedCard": `PanUploadSection_uploadedCard__GCfkq`,
	"uploadedLeft": `PanUploadSection_uploadedLeft__fC9bk`,
	"successCheckIcon": `PanUploadSection_successCheckIcon__O99gu`,
	"uploadedInfo": `PanUploadSection_uploadedInfo__DuLyn`,
	"uploadedTitle": `PanUploadSection_uploadedTitle__kVpEi`,
	"uploadedSubtitle": `PanUploadSection_uploadedSubtitle__FI36q`,
	"panBadge": `PanUploadSection_panBadge__pljcR`,
	"fileNameText": `PanUploadSection_fileNameText__+QkoJ`,
	"changeFileBtn": `PanUploadSection_changeFileBtn__SLh1Y`,
	"errorMessage": `PanUploadSection_errorMessage__Hf4Ba`
};
export default ___CSS_LOADER_EXPORT___;
